import NavBar from "./components/NavBar";
import SideBar from "./components/SideBar";
import {Route, Switch} from "react-router-dom";
import {Callback} from "./auth/signinCallback";
import logoutClient from "./auth/Logout";
import {PrivateRoute} from "./PrivateRoute";
import ProjectSettings from "./components/admin/projects/ProjectSettings";
import Projects from "./components/admin/Projects";
import FormBuilder from "./components/forms/FormBuilder";
import FormViewer from "./components/forms/FormViewer";
import ListSettings from "./components/admin/projects/lists/listSettings";
import DataSourceSettings from "./components/admin/DataSource/dsSettings";
import DataSource from "./components/admin/DataSource/DataSource";
import Users from "./components/admin/Users";
import Roles from "./components/admin/Roles";
import React, { useRef } from "react";
import {useKeycloak} from "./config";
import Institutions from "./components/admin/Institutions";
import appConfigurations from "./components/admin/appConfigurations";
import { AuthConsumer } from "./auth/authProvider";
import ReportBuilder from "./components/reports/ReportBuilder";
import ReportViewer from "./components/reports/ReportViewer";
import ReportSettings from "./components/reports/ReportSettings";

const MainApp = (props) => {
    const FormViewerRef = useRef()

   const [toggleFormRender, setToggleFormRender] = React.useState('');

    function getFormInfo(){
        if (document.getElementById('userInst')) {
            let el = document.getElementById('userInst'), Response = [], Responses = [{ 'Answer_ID': 0, 'Answer_Text': '' }]
            Responses[0]['Answer_ID'] = parseInt(el.value)
            Responses[0]['Answer_Text'] = el.options[el.selectedIndex].text
            Response = [...Responses]
            console.clear()
            FormViewerRef.current.handleResponse(null, Response)
            setToggleFormRender(el.value)
        }
    }

    return (
        <div className={props.showSidebar ? "" : "sidenav-toggled"}>
            <div className="nav-fixed">
                <NavBar
                    userDetails={props.userDetails}
                    handleToggle={props.handleToggle}
                    keycloakLogout={props.keycloakLogout}
                    handleSetNavPx={props.handleSetNavPx}
                    navPx={props.navPx}
                    OnUpdate={getFormInfo}
                />
                <div id="layoutSidenav">
                    {props.showSidebar && !props.loading && (
                        <SideBar
                            userDetails={props.userDetails}
                            history={props.history}
                            navPx={props.navPx}
                            handleToggle={props.handleToggle}
                        />
                    )}
                    <div id="layoutSidenav_content">
                        <main>
                            <Switch>
                                <Route
                                    exact={true}
                                    path="/signin-callback"
                                    component={Callback}
                                />
                                {
                                    !useKeycloak &&
                                    <Route exact={true} path="/logout" component={logoutClient}/>
                                }
                                <PrivateRoute
                                    path="/projectSettings"
                                    component={ProjectSettings}
                                />
                                <PrivateRoute path="/projects" component={Projects}/>
                                <PrivateRoute path="/institutions" component={Institutions}/>
                                <PrivateRoute path="/appConfigurations" component={appConfigurations}/>
                                <PrivateRoute path="/reportBuilder" component={ReportBuilder}/>
                                <PrivateRoute path="/reportViewer" component={ReportViewer}/>
                                <PrivateRoute path="/reportSettings" component={ReportSettings}/>
                                <PrivateRoute path="/formBuilder" component={FormBuilder}/>
                                {/* <PrivateRoute path="/forms" component={Forms} /> */}
                                <PrivateRoute path="/form" component={FormViewer}/>
                                <PrivateRoute
                                    path="/listSettings"
                                    component={ListSettings}
                                />
                                <PrivateRoute
                                    path="/dataSourceSettings"
                                    component={DataSourceSettings}
                                />
                                <PrivateRoute path="/dataSource" component={DataSource}/>
                                <PrivateRoute path="/users" component={Users}/>
                                <PrivateRoute path="/roles" component={Roles}/>
                                <Route
                                    path="/projectViewer"
                                    render={props => (
                                        <AuthConsumer>
                                            {({ isAuthenticated, signinRedirect }) => {
                                                if (isAuthenticated()) {
                                                    return <FormViewer {...props} 
                                                                key={toggleFormRender} selectedInst={toggleFormRender} ref={FormViewerRef}/>;
                                                } else {
                                                    signinRedirect();
                                                }
                                            }}
                                        </AuthConsumer>
                                    )}
                                />
                                <Route
                                    path="/"
                                    exact={true}
                                    render={props => (
                                        <AuthConsumer>
                                            {({ isAuthenticated, signinRedirect }) => {
                                                if (isAuthenticated()) {
                                                    return <FormViewer {...props} 
                                                                key={toggleFormRender} selectedInst={toggleFormRender} ref={FormViewerRef}/>;
                                                } else {
                                                    signinRedirect();
                                                }
                                            }}
                                        </AuthConsumer>
                                    )}
                                />
                            </Switch>
                        </main>
                        <footer className="footer mt-auto footer-light">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-md-6 small">
                                        Copyright &copy; The Regents of the University of
                                        Michigan
                                    </div>
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainApp;